var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.624,
    height: 24,
    viewBox: "0 0 22.624 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Roles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shield-check-solid",
    d: "M27.943.137a1.528,1.528,0,0,0-1.263,0L17.8,3.9A2.926,2.926,0,0,0,16,6.6c.024,4.676,1.947,13.23,10.068,17.119a2.879,2.879,0,0,0,2.489,0C36.677,19.829,38.6,11.274,38.623,6.6a2.926,2.926,0,0,0-1.805-2.7Zm4.694,9.714L26.6,15.884a1.127,1.127,0,0,1-1.6,0L21.99,12.867a1.13,1.13,0,1,1,1.6-1.6L25.8,13.485l5.232-5.236a1.13,1.13,0,1,1,1.6,1.6Z",
    transform: "translate(-16)",
    fill: "inharit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.6001dbd25b090cbcf626f80446b32fdb.svg";
export { ForwardRef as ReactComponent };